import { CLIENTS_LINK_RESOURCE_ACCESS_MAP } from "@lib/constants/clients-links";
import { checkPathnamePattern } from "@lib/utils/url/check-pathname-pattern";
import { ClientsLinkPermissions } from "../types/clients-links.types";

export const checkResourceAccess = (
  pathname: string,
  permissions: ClientsLinkPermissions[],
): boolean => {
  // Check if pathname matches one of the patterns
  for (const [pattern, requiredPermissions] of Object.entries(
    CLIENTS_LINK_RESOURCE_ACCESS_MAP,
  )) {
    if (checkPathnamePattern(pathname, pattern)) {
      // If there's a match, check if at least one of the required permissions is present
      return requiredPermissions.some((permission) =>
        permissions.includes(permission),
      );
    }
  }

  // If pathname doesn't match any pattern, return false
  return false;
};

export const checkClientViewPath = (pathname: string): boolean => {
  const pathSegments = pathname.split("/").filter(Boolean);

  return pathSegments.length >= 2 && pathSegments[0] === "client";
};
